import { requst } from '../config'

// HSE 日报 - 日历上数据
export const getHealthCalendarApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/monitor/health/diary/listByCalendar?
            startDay=${params.startDay}
            &endDay=${params.endDay}
            &locationId=${params.locationId}
            &projectId=${params.projectId}
            &dateType=${params.dateType}`.replace(/\s*/g, '')
            break
        case 'week':
            break
        case 'year':
            break
        default:
            break
    }
    return requst.get(url)
}

// 字典数据树
export const getHealthDictTreeApi = dictType => {
    const url = `/system/dict/data/tree?dictType=${dictType}&status=Y`
    return requst.get(url)
}

// 查询日期
export const getHealthByDateApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/monitor/health/diary/date?
            produceDate=${params.produceDate}
            &locationId=${params.locationId}
            &projectId=${params.projectId}
            &dateType=${params.dateType}`.replace(/\s*/g, '')
            break
        case 'week':
            break
        case 'year':
            break
        default:
            break
    }
    return requst.get(url)
}

// 查询 id
export const getHealthByIdApi = id => {
    const url = `/monitor/health/diary/${id}`
    return requst.get(url)
}

// 提交 Health 总结
export const postHealthCommentApi = commentData => {
    const url = `/monitor/health/diary`
    return requst.post(url, { ...commentData })
}

// 修改 Health 总结
export const putHealthCommentApi = (commentData, id) => {
    const url = `/monitor/health/diary`
    return requst.put(url, { ...commentData, id })
}

// 获取 Health 事件数据
export const getEventsDataApi = id => {
    const url = `/monitor/health/diary/event/list?diaryId=${id}`
    return requst.get(url)
}

// 提交 Health 事件
export const postEventsDataApi = (eventData, id) => {
    const url = `/monitor/health/diary/event/addOrUpdateBatch/${id}`
    return requst.post(url, eventData) 
}


